import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { SALES_TAX_PATH } from '../../../../config/paths';
import {
  clearSalesTax,
  getSalesTax,
  putSalesTax,
} from '../../../../actions';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import SalesTaxForm from './SalesTaxForm';

const EditSalesTax = ({
  breadcrumbs,
  dispatchGetSalesTax,
  dispatchClearSalesTax,
  dispatchPutSalesTax,
  match: {
    params: { id: salesTaxId },
  },
  loading,
  salesTax,
}) => {
  useLayoutEffect(() => {
    dispatchGetSalesTax({ salesTaxId });

    return () => dispatchClearSalesTax();
  }, []);

  const onSubmit = (formValues) =>
    dispatchPutSalesTax(salesTaxId, {
      ...formValues,
      countryId: formValues.countryId.id,
    });

  const generateInitialValues = ({
    taxRate,
    country,
  }) => ({
    taxRate,
    countryId: {
      value: country.countryCode,
      label: country.name,
      id: country.id
    },
  });

  let content;

  if (loading) content = <Loader />;
  else if (salesTax.isEmpty())
    content = <NoDataResource returnPage={SALES_TAX_PATH} />;
  else
    content = (
      <SalesTaxForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(salesTax.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Impuesto a la Venta"
      subtitle="Editar impuesto a la venta"
      content={content}
    />
  );
};

EditSalesTax.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearSalesTax: PropTypes.func.isRequired,
  dispatchGetSalesTax: PropTypes.func.isRequired,
  dispatchPutSalesTax: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  salesTax: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditSalesTax.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearSalesTax: clearSalesTax,
  dispatchGetSalesTax: getSalesTax,
  dispatchPutSalesTax: putSalesTax,
};

const mapStateToProps = (
  { AccountingUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Impuestos a la Venta',
      href: SALES_TAX_PATH,
    },
    {
      text: 'Ver',
      href: `${SALES_TAX_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  salesTax: AccountingUnit.SalesTax.getIn(['current', 'content']),
  loading: !AccountingUnit.SalesTax.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSalesTax);
